export const COLORS = {
	white: "#FFF",
	magenta: "#fe2c85",
	black: "#000",
	background: "#080826",
	boxColor: "#151e2a",
  whiteWithOpacity: "#ffffffb3"
};
